import { render, staticRenderFns } from "./IconClocks.vue?vue&type=template&id=69a7f5a0&"
import script from "./IconClocks.vue?vue&type=script&lang=js&"
export * from "./IconClocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports